import { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import NavigationMenu from "./navigationMenu";
import constants from "../constants/constants";


const DesktopNav = ({ pathname }) => {
  const [activeMenu, setActiveMenu] = useState(null);

  const handleMenuHover = (menu) => {
    setActiveMenu(menu);
  };

  return (
    <nav
      style={{
        backgroundColor: constants.RURAL_COLORS.background,
        borderBottom: constants.RURAL_BORDERS.double,
        boxShadow: constants.RURAL_BORDERS.shadow,
        borderRadius: "24px 24px 24px 24px",
        margin: "0 auto",
        maxWidth: "1200px",
        minHeight: "64px",
        position: "relative",
        zIndex: 2,
      }}
      className="w-full py-4 px-8 flex gap-x-10 justify-center font-semibold child:relative mt-2 text-xl"
    >
      {constants.NAV_ITEMS.map((item) =>
        item.items.length > 0 ? (
          <div
            key={item.label}
            className="cursor-pointer pb-2"
            onMouseEnter={() => handleMenuHover(item.label)}
            onMouseLeave={() => handleMenuHover(null)}
            style={{ color: constants.RURAL_COLORS.primary, fontFamily: "serif" }}
          >
            {item.label}
            <FontAwesomeIcon
              icon={faAngleDown}
              className={`ml-2 w-3 h-3 inline-block ${activeMenu === item.label ? "fa-flip-vertical" : ""
                }`}
            />
            {activeMenu === item.label && (
              <div
                style={{
                  background: constants.RURAL_COLORS.accent,
                  border: constants.RURAL_BORDERS.rope,
                  borderRadius: "10px",
                  boxShadow: constants.RURAL_BORDERS.shadow,
                }}
              >
                <NavigationMenu items={[...item.items]} />
              </div>
            )}
          </div>
        ) : (
          <Link
            key={item.label}
            to={item.href}
            className={pathname === item.href ? "text-primary" : ""}
            style={{ color: constants.RURAL_COLORS.primary, fontFamily: "serif" }}
          >
            {item.label}
          </Link>
        )
      )}
    </nav>
  );
};

export default DesktopNav;
